import React from 'react'
import { useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import {
  Bars3Icon,
  XMarkIcon,
} from '@heroicons/react/24/outline'
import { Link, useLocation } from 'react-router-dom'


const navigation = [
    { name: 'Home', href: '/' },
    { name: 'Contact', href: '/contact' },
    { name: 'Blog', href: '/blog' },
    // { name: 'Testimonials', href: '/testimonials' },
    { name: 'Our Services', href: '/services' },
  ]
const Header = () => {
const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
const location = useLocation()

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  
  const isActive = (href) => {
    if (href === '/' && location.pathname === '/') return true
    if (href !== '/' && location.pathname.startsWith(href)) return true
    return false
  }
  return (
    <>
        <header className="absolute inset-x-0 top-0 z-50 backdrop-blur-sm bg-white/80">
        <nav className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8" aria-label="Global">
          <div className="flex lg:flex-1">
            <a href="#" className="-m-1.5 p-1.5 transition-transform duration-200 hover:scale-105">
              <span className="sr-only">Executivehaven</span>
              <img
                className="h-10 w-auto"
                src="https://admin.executivehaven.org/static/assets/img/logo.png"
                alt="Executive Haven Logo"
              />
            </a>
          </div>
          <div className="flex lg:hidden">
            <button
              type="button"
              className="-m-2.5 inline-flex items-center justify-center rounded-lg p-2.5 text-gray-700 transition-colors duration-200 hover:bg-gray-100 hover:text-gray-900"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="hidden lg:flex lg:gap-x-8">
            {navigation.map((item) => (
              <Link 
                key={item.name} 
                to={item.href} 
                onClick={handleLinkClick}
                className={`relative px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-200 ${
                  isActive(item.href)
                    ? 'text-white shadow-md'
                    : 'text-gray-700 hover:text-primary-600 hover:bg-primary-50'
                }`}
                style={isActive(item.href) ? { backgroundColor: '#3BC52B' } : {}}
              >
                {item.name}
              </Link>
            ))}
          </div>
          <div className="hidden lg:flex lg:flex-1 lg:justify-end">
            <a 
              href="https://calendly.com/admin-executivehaven/discovery-call"
              className="rounded-lg px-4 py-2 text-sm font-semibold text-white shadow-md transition-all duration-200 hover:shadow-lg hover:scale-105"
              style={{ backgroundColor: "#3BC52B" }}
              onMouseEnter={(e) => e.target.style.backgroundColor = "#32A526"}
              onMouseLeave={(e) => e.target.style.backgroundColor = "#3BC52B"}
            >
              Get Started
            </a>
          </div>
        </nav>
        <Dialog className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
          <div className="fixed inset-0 z-50 bg-black/20 backdrop-blur-sm" />
          <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 shadow-2xl sm:max-w-sm">
            <div className="flex items-center justify-between">
              <a href="#" className="-m-1.5 p-1.5">
                <span className="sr-only">Executivehaven</span>
                <img
                  className="h-8 w-auto"
                  src="https://admin.executivehaven.org/static/assets/img/logo.png"
                  alt="Executive Haven Logo"
                />
              </a>
              <button
                type="button"
                className="-m-2.5 rounded-lg p-2.5 text-gray-700 transition-colors duration-200 hover:bg-gray-100"
                onClick={() => setMobileMenuOpen(false)}
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 flow-root">
              <div className="-my-6 divide-y divide-gray-200">
                <div className="space-y-2 py-6">
                  {navigation.map((item) => (
                    <Link
                      key={item.name}
                      to={item.href}
                      className={`-mx-3 block rounded-xl px-4 py-3 text-base font-bold transition-all duration-200 ${
                        isActive(item.href)
                          ? 'text-white shadow-lg'
                          : 'text-gray-900 hover:bg-primary-50 hover:text-primary-700'
                      }`}
                      style={isActive(item.href) ? { backgroundColor: '#3BC52B' } : {}}
                      onClick={() => {
                        setMobileMenuOpen(false)
                        handleLinkClick()
                      }}
                    >
                      {item.name}
                    </Link>
                  ))}
                </div>
                <div className="py-6">
                  <a 
                    href="https://calendly.com/admin-executivehaven/discovery-call"
                    className="block w-full rounded-xl bg-primary-600 px-4 py-3 text-center text-base font-semibold text-white transition-all duration-200 hover:bg-primary-700"
                  >
                    Get Started
                  </a>
                </div>
              </div>
            </div>
          </DialogPanel>
        </Dialog>
      </header>
    </>
  )
}

export default Header